import { NICmsContentField } from '@icms/core/content';

export const productSizeGuideConfig = {
    id: 'product-size-guide',
    block: {
        url: 'product-size-guide'
    },
    onDemandOnly: true,
    name: 'Product size guide modal',
    description: 'Product size guide modal component',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'modal_title',
            title: 'Modal title',
            default: 'Lorem ipsum',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'dropdown_label',
            title: 'Dropdown label',
            default: 'Lorem ipsum',
            required: true
        },
        {
            key: 'enable_how_to_measure',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Enable “How to measure”',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'tables',
            title: 'Tables',
            itemName: 'Table',
            defaultSize: 1,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Lorem ipsum',
                    required: true
                },
                {
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Components',
                    default: []
                }
            ]
        },
        {
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            default: []
        }
    ]
};
